export const COST_PERIODS = ['hourly', 'daily', 'monthly'] as const;
